import { format } from 'date-fns';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DATE_FORMAT_API } from '../../../../../../../../@constants/date';
import { RoomMoveReportFormModel } from '../../models';

export const getDefaultValues = (globalSettings: GlobalSettingsModel): RoomMoveReportFormModel => ({
  from: format(new Date(), DATE_FORMAT_API),
  to: format(new Date(), DATE_FORMAT_API),
  users: [],
  file_type: 'pdf',
});
